/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default [
  {
    url: "/",
    name: "Dashboard",
    slug: "dashboard",
    icon: "HomeIcon",
  },
  {
    header: "Bezorgservice",
    items: [
      {
        url: "/delivery/overview",
        slug: "delivery-overview",
        name: "Overzicht",
        icon: "MapIcon"
      },
      {
        url: "/delivery/deliverers",
        slug: "deliverer-overview",
        name: "Bezorgers",
        icon: "TruckIcon"
      }
    ]
  },
  {
    header: "Bedrijven",
    items: [
      {
        url: "/companies/list",
        slug: "companies-list",
        name: "Overzicht",
        icon: "HomeIcon"
      },
      {
        url: "/companies/:slug/menu",
        slug: "companies-menu",
        name: "Menu",
        icon: "BookOpenIcon"
      },
      {
        url: "/companies/:slug/orders",
        slug: "companies-orders",
        name: "Bestellingen",
        icon: "ShoppingCartIcon"
      },
      {
        url: "/companies/:slug/settings",
        slug: "companies-settings",
        name: "Instellingen",
        icon: "SettingsIcon"
      }
    ]
  }
]
